import React, { Fragment, useState } from 'react'
import { Typography, Grid, TextField, Button, Chip, Box } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { Save } from '@material-ui/icons'
import i18n from 'i18next'
import { useSelector } from 'react-redux'
import { Trans } from 'react-i18next'
import { useAuth, useFetch } from '../context/useFetch'
import { useAlert, useUpdate } from '../reducer'

export default () =>
  useFetch(
    ({ fetch }) => ({
      profile: fetch('profile')
    }),
    () => (
      <Fragment>
        <Typography variant="h2" component="h1">
          <Trans i18nKey="profile.candidat.cover_letter_tab" />
        </Typography>

        <Grid className="profileSection">
          <Box mb={4}>
            <Typography variant="h3" component="h2">
              <Trans i18nKey="job_offer.job_apply.cover_letter_title" />
            </Typography>

            <Typography>
              <Trans i18nKey="job_offer.job_apply.cover_letter_tooltip_text" />
            </Typography>
          </Box>

          <ProfileCoverLetter />
        </Grid>
      </Fragment>
    )
  )

const Tags = ['{company_name}', '{job_offer}']

export const ProfileCoverLetter = ({ extraSaveHandler }) => {
  const profile = useSelector((state) => state.profile)

  const update = useUpdate()
  const auth = useAuth()
  const alert = useAlert()

  if (!profile) return null

  const [coverLetter, setCoverLetter] = useState(
    (profile.default_cover_letter || '').length > 0
      ? profile.default_cover_letter
      : i18n.t('job_offer.job_apply.motivation_letter', { firstName: profile.first_name, lastName: profile.last_name })
  )

  const handleCoverLetter = () => {
    auth
      .fetch('profile', { method: 'PATCH', body: { profile: { default_cover_letter: coverLetter } } })
      .then((updatedProfile) => {
        update(['profile', 'default_cover_letter'], updatedProfile.default_cover_letter)
        alert('notice', <Trans i18nKey="alerts.saved_data" />)
        extraSaveHandler && extraSaveHandler()
      })
      .catch(() => {
        alert('error', <Trans i18nKey="alerts.saved_error" />)
      })
  }

  const copyChip = (tag) => {
    navigator.clipboard.writeText(tag)
    alert('notice', <Trans i18nKey="job_offer.new_job_offer.editor_dictionnary.codeCopied" />)
  }

  return (
    <Grid container spacing={2}>

      <Grid item xs={12}>
        <Alert severity="info">
          {i18n.t('profile.candidat.cover_letter.tags_explanation')}
        </Alert>
      </Grid>
      <Grid item xs={12}>
        {Tags.map((tag) => (
          <Chip label={tag} style={{ margin: 1 }} onClick={() => copyChip(tag)} />
        ))}
      </Grid>

      <Grid item xs={12}>
        <TextField
          label={i18n.t('profile.candidat.cover_letter_tab')}
          id="coverletter-description"
          fullWidth
          multiline
          InputProps={{ disableUnderline: true }}
          variant="filled"
          value={coverLetter}
          onChange={(e) => {
            setCoverLetter(e.target.value)
          }}
        />
      </Grid>

      <Grid item xs={12} align="right">
        <Button
          id="coverletter-save"
          variant="contained"
          color="primary"
          size="large"
          startIcon={<Save />}
          disabled={coverLetter === i18n.t('job_offer.job_apply.motivation_letter', { firstName: profile.first_name, lastName: profile.last_name })}
          onClick={handleCoverLetter}>
          {i18n.t('generic.save')}
        </Button>
      </Grid>
    </Grid>
  )
}